import { render, staticRenderFns } from "./InputDescription.vue?vue&type=template&id=290977b6&scoped=true"
import script from "./InputDescription.vue?vue&type=script&lang=js"
export * from "./InputDescription.vue?vue&type=script&lang=js"
import style0 from "./InputDescription.vue?vue&type=style&index=0&id=290977b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290977b6",
  null
  
)

export default component.exports